import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './OverviewSkeleton.styles.scss';

/**
 * Skeleton component for Competitors Overview section
 * Displays loading state for barriers, timeline, and manufacturers table
 */
const OverviewSkeleton: React.FC = () => {
  return (
    <div className="overview-skeleton">
      {/* Entry Barriers Section Skeleton */}
      <div className="entry-barriers-skeleton">
        {[1, 2, 3].map(index => (
          <div key={index} className="barrier-metric-skeleton">
            <Skeleton width="5rem" height="3rem" style={{ margin: '0 auto 0.5rem' }} />
            <Skeleton width="8rem" height="1rem" style={{ margin: '0 auto' }} />
          </div>
        ))}
      </div>

      {/* Timeline Section Skeleton */}
      <div className="timeline-skeleton">
        <Skeleton width="10rem" height="1.25rem" style={{ marginBottom: '1rem' }} />
        <Skeleton width="100%" height="8rem" borderRadius="0.75rem" />
      </div>

      {/* Manufacturers Table Section Skeleton */}
      <div className="manufacturers-table-skeleton">
        <Skeleton width="12rem" height="1.25rem" style={{ marginBottom: '1rem' }} />
        <Skeleton width="100%" height="20rem" borderRadius="0.75rem" />
      </div>
    </div>
  );
};

export default OverviewSkeleton;
